import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useTawkControl from "../../hooks/useTawkControl";

const TawkController = () => {
  const location = useLocation();
  const {hideWidget, showWidget} = useTawkControl()

  useEffect(() => {
    if (!window.Tawk_API) return;

    const hiddenPaths = ["/chat"];

    const shouldHide = hiddenPaths.some((path) => location.pathname.includes(path));

    if (shouldHide) {
      hideWidget();
    } else {
      showWidget();
    }
  }, [location]);

  return null;
};

export default TawkController;